import api from './api';

export const getAdminDashboard = async () => {
  const response = await api.get('/admin/dashboard/');
  return response.data;
};

export const getAdminUsers = async () => {
  const response = await api.get('/admin/users/');
  return response.data;
};

export const updateAdminUser = async (userId, payload) => {
  const response = await api.patch(`/admin/users/${userId}/`, payload);
  return response.data;
};

export const getAdminProducts = async () => {
  const response = await api.get('/admin/products/');
  return response.data;
};

export const updateAdminProduct = async (productId, payload) => {
  const response = await api.patch(`/admin/products/${productId}/`, payload);
  return response.data;
};

export const deleteAdminProduct = async (productId) => {
  const response = await api.delete(`/admin/products/${productId}/`);
  return response.data;
};

export const getAdminOrders = async () => {
  const response = await api.get('/admin/orders/');
  return response.data;
};

export const updateAdminOrderStatus = async (orderId, status) => {
  const response = await api.patch(`/admin/orders/${orderId}/status/`, { status });
  return response.data;
};

export const getPendingSellers = async () => {
  try {
    const response = await api.get('/admin/pending-sellers/');
    return response.data;
  } catch (err) {
    const errorMessage = err.response?.data?.message || 'Failed to fetch pending sellers';
    console.error('Error in getPendingSellers:', errorMessage);
    throw new Error(errorMessage);
  }
};

export const verifySeller = async (uid, status) => {
  if (!['approved', 'rejected'].includes(status)) {
    throw new Error('Invalid status for verification.');
  }
  try {
    const response = await api.post(`/admin/verify-seller/${uid}/`, { status });
    return response.data;
  } catch (err) {
    const errorMessage = err.response?.data?.message || 'Failed to verify seller';
    console.error('Error in verifySeller:', errorMessage);
    throw new Error(errorMessage);
  }
};

export const getAdmins = async () => {
  try {
    const response = await api.get('/admin/admins/');
    return response.data;
  } catch (err) {
    const errorMessage = err.response?.data?.message || 'Failed to fetch admins';
    console.error('Error in getAdmins:', errorMessage);
    throw new Error(errorMessage);
  }
};

export const addAdmin = async (email) => {
  try {
    const response = await api.post('/admin/admins/', { email });
    return response.data;
  } catch (err) {
    const errorMessage = err.response?.data?.message || 'Failed to add admin';
    console.error('Error in addAdmin:', errorMessage);
    throw new Error(errorMessage);
  }
};

export const removeAdmin = async (uid) => {
  try {
    const response = await api.delete(`/admin/admins/${uid}/`);
    return response.data;
  } catch (err) {
    const errorMessage = err.response?.data?.message || 'Failed to remove admin';
    console.error('Error in removeAdmin:', errorMessage);
    throw new Error(errorMessage);
  }
};

